<template>
<div class="container" id="albumsView">
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <h2 class="VIDEOS">ALBUMS <span class="alt-title">/ VIDEOS</span></h2>
        </div>
      </div>

    <div class="row album-list">
      <div class="col-6 col-xs-6 col-sm-6 col-md-2 " v-for="album in albums">
          <div class="boximg" v-on:click="getVideo(album)" v-scroll-to="'#albumsView'">
            <img class="imagen" :src="album.image">
            <div class="overlay">
              <div class="text"></div>
            </div>
          </div>
        <p class="text-center album-solo-name">{{album.name}}</p>
        <p class="text-center album-solo-date">{{album.date}}</p>
      </div>
    </div>
  

      <div class="row" id>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="embed-responsive embed-responsive-16by9">
            <youtube :video-id="videoId"></youtube>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <p class="album-title">{{currentSelect.name}}</p>
          <p class="album-year">{{currentSelect.date}}</p>
          <p class="album-desc" v-html="currentSelect.description"></p>
        </div>
      </div>
    </div>

  </div>
  <!--
  <div class="row album-list">
    <div class="col"
         v-for="album in albums">
      <div class="containe" v-on:click="getVideo(album)" v-scroll-to="'#albumsView'">
        <div class="hover-second-image-over-first-image"></div>
        <img 
             class="album-image"
             :src="album.image">
        </div>
        <p class="text-center album-solo-name">{{album.name}}</p>
        <p class="text-center album-solo-date">{{album.date}}</p>
    </div>
  </div>
  -->

  
    <div class="row album-list youtube-channel">
      <div class="col-12 col-xs-12 col-sm-6 col-md-3 text-center ">
        <a href="https://www.youtube.com/channel/UC63lp7dqwdxIbYk1shbeVWA" target="_blank">
          <img src="../assets/youtub.png" class="youtubelogo" alt="Yutube Channel">
        </a>
      </div>  

      <div class="col-6 col-xs-6 col-sm-6 col-md-2 " v-for="video in videos">
          <div class="boximg" v-on:click="getVideo(video)" v-scroll-to="'#albumsView'">
            <img class="imagen" :src="video.image">
            <div class="overlay2">
              <div class="text"></div>
            </div>
          </div>
          <div :src="video.image">
            <p  class="text-center album-solo-name2">{{video.name}}</p>
            <p  class="text-center album-solo-date">{{video.date}}</p>
          </div>
      </div>
    </div>


</div>

</template>



<script>


import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed';
export default {
  name: 'name',
  methods: {
    getVideo: function(name) {
      this.currentSelect = name
      this.videoId = this.$youtube.getIdFromURL(name.video)
    // console.log(this.videoId)
      console.log ("aqui")

      this.$analytics.fbq.event('ViewContent', {
        content_name: name.name
      })

      this.$ga.event('View', 'Almbums', name.name)

    }
  },
  mounted: function() {
    this.getVideo(this.albums[0])
    this.$ga.page('/')
  },
  data() {
    return {
      videoId: '',
      currentSelect: '',
      videos : [
        {
          'name': 'Yilmer Vivas - Tarde/Noche',
          'date': 2018,
          'image': '/static/albums/img2.png',
          'description': 'Elementos de la cultura venezolana y Latinoamericana. Sonidos electrónicos y tradicionales que suenan y se mezclan. Los Angeles, CA. Enero 2018.',
          'video': 'https://youtu.be/TJ2lG_FFH2s',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Yilmer Vivas - Intro, Joropo y Tambor',
          'date': 2018,
          'image': '/static/albums/img1.png',
          'description': 'Haciendo homenaje al intro de Estampa, un tema del disco Mundo de Rubén Blades, una obra de arte. Un disco que cambió mi vida! ',
          'video': 'https://youtu.be/DbFAqj7wEg4',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Yilmer Vivas - Voodoo Child - Drum Solo',
          'date': 2018,
          'image': '/static/albums/img3.png',
          'description': 'Yilmer Vivas Project - Voodoo Child - Drum Solo',
          'video': 'https://youtu.be/shpmQq1-L1s',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        }
      ],
      albums: [
        {
          'name': 'SoñArtes',
          'date': 2017,
          'image': '/static/albums/sonartes.png',
          'description': 'SoñArtes, was the purest and most sincere word we found to name this non-profit project, which is created for a very clear objective: To help in the artistic growth and development of children and adolescents with scarce economic resources.',
          'video': 'https://www.youtube.com/watch?v=ZABV8Z-6vi8',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Luzia DVD',
          'date': 2016,
          'image': '/static/albums/luzia.png',
          'description': 'Luzia, written and directed by Daniele Frinzi Pasca. A show based on Mexico with traditional elements and with Latin American sounds and colors all exposed in the contemporary world. A magical and surreal creation of Cirque du Soleil uniting artist of several part of the world.',
          'video': 'https://www.youtube.com/watch?v=-qZCbmwp4dc',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': 'http://es.cirquedusoleil.wikia.com/wiki/LUZIA'
        },
        {
          'name': 'Vida',
          'date': 2016,
          'image': '/static/albums/vida.png',
          'description': 'The Venezuelan singer Carmela Ramírez, together with the pianist Gabriel Chakarji, published her album Vida, with which they pay homage to Venezuelan and Latin American music under her jazz influences.',
          'video': 'https://www.youtube.com/watch?v=n8-tDPIfPkw',
          'youtube': '',
          'cdbany': 'https://store.cdbaby.com/cd/carmelaramirezgabrielcha',
          'spotify': 'https://open.spotify.com/album/0xWwmpUUQQ6YIkeKkmXXwy',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Walking Hands',
          'date': 2014,
          'image': '/static/albums/manocaminantes.jpg',
          'description': '"SOL NARANJA" a song obtained from the new album "WALKING HANDS" of Leonard Jacome and his Strings Under Pressure (Totally recorded "live" at the studio). Produced and Directed by: Leonard Jacome. ',
          'video': 'https://youtu.be/h_3qUPNUemg',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Viva Piazzola',
          'date': 2014,
          'image': '/static/albums/eddymarcano.png',
          'description': 'Eddy Marcano is one of the great Venezuelan violinists and conductors, also recognized as one of the main exponents of the instrument throughout the continent. Viva Piazzola, BOD Cultural Center May 2013',
          'video': 'https://youtu.be/XLI8mDlrMXM',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        },
        {
          'name': 'Latin American Classics',
          'date': 2011,
          'image': '/static/albums/latinamerica.png',
          'description': 'Stretching from Mexico to Argentina and covering miles of lush, idyllic landscape, Latin America has long been a source of inspiration for all manner of artists. This engaging release details a wonderful collection of music by composers native to the continent, all of whom have sought to capture its identity in their work. ',
          'video': 'https://youtu.be/X15Awd5yqaM',
          'youtube': '',
          'cdbany': '',
          'spotify': '',
          'itunes': '',
          'web': ''
        }
      ]
    }
  }
}

</script>

<style scoped="">




<style>



.boximg {
  position: relative;
  width: 50%;
}

.imagen {
  display: block;
  width: 100%;
  height: auto;
}

.container{
  margin-top: 100px !important;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: block;
  margin: 0 auto;
  opacity: 0;
  transition: .5s ease;
  background: url(../assets/over.png) no-repeat;
  background-size: contain;
  cursor:pointer;
}

.overlay2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: block;
  margin: 0 auto;
  opacity: 0;
  transition: .5s ease;
  
  background-size: contain;
  cursor:pointer;

}

.boximg:hover .overlay {
  opacity: 0.7;
}

.text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}



#albumsView{
  margin-top: 60px;
}
  
.containe{
   position: relative;
   
}

.youtubelogo{
  margin-top: 20px;
}

.containe .hover-second-image-over-first-image {
  width: 100%;
  height: 100%;
  background: url(../assets/over.png) no-repeat;
  background-size: contain;
  opacity: 0;
  position: absolute;
  cursor:pointer;
  left: -10;
  z-index: 10;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  display: block;
   margin: 0 auto;
}

.containe:hover .hover-second-image-over-first-image {
  opacity: .7;
}

.VIDEOS {
  font-family: 'Open Sans', sans-serif;
  font-size: 35px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: rgb(0, 0, 0);
  color: var(--black);
  margin-bottom: 20px;
  margin-top: 30px;
}

.VIDEOS .alt-title {
  font-weight: normal;
}




@media (max-width: 991px) {
  .imagew {
    margin-bottom: 40px;
  }
}

.album-list {
  margin-top: 60px;
}

.album-desc {
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: 0.4px;
  text-align: justify;
  color: rgb(0, 0, 0);
  color: var(--black);
}

.youtube-channel{
  background: black;
  padding-top: 15px;
}

.album-image {
  cursor: pointer;
  height: 150px;
  width: 160px;
}

.album-image2{
  width: 100%;
}

.album-year {
  font-family: 'Open Sans', sans-serif;
  font-size: 30px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
  text-align: justify;
  color: rgb(66, 66, 66);
}

.album-title {
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
  text-align: justify;
  color: rgb(110, 186, 208);
  margin-bottom: 5px;


}

.VIDEOS {
  font-family: 'Open Sans', sans-serif;
  font-size: 35px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: rgb(0, 0, 0);
  color: var(--black);
  margin-bottom: 20px;
  margin-top: 30px;
}

.VIDEOS .alt-title {
  font-weight: normal;
}

.album-solo-name {
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgb(110, 186, 208);
  margin-bottom: 5px !important;
}

.album-solo-name2{
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: white;
  margin-bottom: 5px !important;
}

.album-solo-date {
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: justify;
  color: rgb(67, 67, 67);
}


</style>



// WEBPACK FOOTER //
// src/components/YilmerAlbums.vue